import { useEffect, useState } from 'react'
import Form, {
  Input,
  Select,
  Textarea
} from '../../../../../../components/Form'
import { useToast } from '../../../../../../hooks/toast'
import { FormContainer } from './styles'
import { SearchComponentIngredient } from './SearchComponentIngredient'
import { genericMaskWithTwoZeroWithPoint } from 'utlis/mask'

type TypesFormProps = {
  handleClickOnAddIngredient?: (dishIngredient: IDishIngredient) => void
  handleClickOnEditIngredient?: (dishIngredient: IDishIngredient) => void
  initialValues?: {
    dish_id?: number
    dish_ingredient?: IDishIngredient
  }
  typeForm: 'create' | 'update'
}

export const FormAddIngredient = ({
  handleClickOnAddIngredient,
  handleClickOnEditIngredient,
  initialValues,
  typeForm
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()

  const [defaultValues, setDefaultValues] = useState<IDishIngredient>()
  const [ingredient, setIngredient] = useState<number>()
  const [ingredientName, setIngredientName] = useState<string>()
  const [unitMeasure, setUnitMeasure] = useState<INGREDIENT_TYPES>()
  const [measure, setMeasure] = useState<string>('')

  useEffect(() => {
    if (initialValues.dish_ingredient) {
      setDefaultValues({
        ...initialValues.dish_ingredient,
        quantity: genericMaskWithTwoZeroWithPoint(
          initialValues.dish_ingredient.quantity
        ),
        factor_cooking: initialValues.dish_ingredient.factor_cooking
          ? genericMaskWithTwoZeroWithPoint(
              initialValues.dish_ingredient.factor_cooking
            )
          : undefined
      })
      setUnitMeasure(initialValues.dish_ingredient.ingredient?.unit_measure)
      setMeasure(initialValues.dish_ingredient.measure)
      setIngredientName(initialValues.dish_ingredient.ingredient?.name)
    }
  }, [initialValues.dish_ingredient])
  const onSubmitForm = async (data: any) => {
    if (!ingredient && typeForm === 'create') {
      addToast({
        type: 'info',
        title: 'Selecione um ingrediente'
      })
      return
    }
    try {
      if (typeForm === 'create') {
        handleClickOnAddIngredient({
          id: 0,
          dish_id: 0,
          ingredient_id: ingredient,
          measure,
          quantity: data.quantity.replace('.', '').replace(',', '.'),
          factor_cooking: data.factor_cooking
            ? data.factor_cooking.replace('.', '').replace(',', '.')
            : undefined,
          description: data.description || '',
          ingredient: {
            name: ingredientName
          }
        })
      } else {
        handleClickOnEditIngredient({
          id: initialValues.dish_ingredient.id,
          dish_id: initialValues.dish_id,
          ingredient_id: initialValues.dish_ingredient.ingredient_id,
          measure,
          quantity: data.quantity.replace('.', '').replace(',', '.'),
          factor_cooking: data.factor_cooking
            ? data.factor_cooking.replace('.', '').replace(',', '.')
            : undefined,
          description: data.description || '',
          ingredient: {
            name: ingredientName
          }
        })
      }
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
      }
    }
  }

  const handleSelectIngredient = (
    id?: number,
    unitMeasure?: INGREDIENT_TYPES,
    ingredientName?: string
  ) => {
    setIngredient(id)
    setIngredientName(ingredientName)
    setUnitMeasure(unitMeasure)
    setMeasure('')
  }

  return (
    <Form onSubmit={onSubmitForm} defaultValues={defaultValues}>
      <>
        <div className="card mb-5 mb-xl-10">
          <FormContainer className="form-body">
            <div>
              <span>
                <a href="/commercial/ingredients/create" target="_blank">
                  Não encontrou o ingrediente?
                  <button className="btn btn-primary btn-sm mx-2" type="button">
                    Adicionae agora!
                  </button>
                </a>
              </span>
            </div>
            <div className="row">
              <div className="col-md-7">
                <SearchComponentIngredient
                  update={typeForm === 'update'}
                  ingredientName={ingredientName}
                  handleSelectIngredient={handleSelectIngredient}
                />
              </div>
              {unitMeasure && ['weight', 'volume'].includes(unitMeasure) && (
                <Select
                  name="measure"
                  label="Medida"
                  options={
                    unitMeasure === 'weight'
                      ? [
                          { name: 'Kilo', value: 'Kilo' },
                          { name: 'Grama', value: 'Grama' },
                          { name: 'Miligrama', value: 'Miligrama' }
                        ]
                      : unitMeasure === 'volume'
                      ? [
                          { name: 'Litro', value: 'Litro' },
                          { name: 'Mililitro', value: 'Mililitro' }
                        ]
                      : []
                  }
                  blank
                  value={measure}
                  onChange={({ target }) => setMeasure(target.value)}
                  defaultValue={''}
                  className="col-md-2"
                  rules={{ required: true }}
                />
              )}
              <Input
                name="quantity"
                label="Qtd."
                price
                className="col-md-2"
                rules={{ required: true }}
              />
              <Input
                name="factor_cooking"
                label="Fator de cocção %"
                price
                className="col-md-2"
              />
            </div>
            <div className="row">
              <Textarea
                name="description"
                className=" col-md-12"
                label="Descrição"
                style={{ minHeight: 120 }}
                defaultValue=""
              />
            </div>
          </FormContainer>
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button type="submit" className="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </>
    </Form>
  )
}
